import * as React from 'react';
import { LocalizedDateTime, DateTimeAccuracy } from '../../../misc/components/LocalizedDateTime';
import { AnalysisAcceptabilityStatus } from '../../../misc/components/analysis/AnalysisAcceptabilityStatus';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faSquarePen, faThumbtack } from '@fortawesome/free-solid-svg-icons';

export interface AnalysisSetCardProps {
    id: string;
    type: string;
    disabled: boolean;
    createdDateTime: string;
    analyst: string;
    acceptability: string;
    checked: boolean;
    onAnalysisSetSelect: (checked: boolean) => void;
    isCurrentSet: boolean;
    isBlinded: boolean;
}

export default class AnalysisSetCard extends React.Component<AnalysisSetCardProps> {
    constructor(props: AnalysisSetCardProps) {
        super(props);
    }

    renderAnalyst = () => {
        if (this.props.analyst) {
            return <div><FontAwesomeIcon icon={faUser} /> {this.props.analyst}</div>;
        } else {
            return null;
        }
    }

    onChange = (e) => {
        if (this.props.isBlinded) {
            return false;
        }
        this.props.onAnalysisSetSelect(!this.props.checked);
    }

    render() {
        const currentIndicatorLabel = this.props.isCurrentSet ? <span className="label label-primary">Current Set</span> : null;
        const icon = this.props.disabled ? <FontAwesomeIcon icon={faThumbtack} aria-hidden="true" /> : <FontAwesomeIcon icon={faSquarePen} aria-hidden="true" />

        return (
            <li>
                <input id={this.props.id} type="checkbox" disabled={this.props.disabled} checked={this.props.checked} onChange={this.onChange} />
                <label htmlFor={this.props.id}>
                    <span className="posh-select-icon">{icon}</span>
                    <span className="posh-select-body">
                        <span className="posh-select-title">{this.props.type} {currentIndicatorLabel}</span>
                        <div className="row">
                            {this.props.isBlinded ? <div className="col-md-8">
                                <p className="text-warning">QC layer is blinded in the current workflow</p>
                            </div> : null}
                            <div className="col-md-8">
                                <div><LocalizedDateTime time={this.props.createdDateTime} accuracy={DateTimeAccuracy.Second} /></div>
                                {this.renderAnalyst()}
                            </div>
                            <div className="col-md-4">
                                <AnalysisAcceptabilityStatus value={this.props.acceptability} />
                            </div>
                        </div>
                    </span>
                </label>
            </li>
        );
    }
}
